import { useState } from "react";
import { Outlet } from "react-router-dom";
import { Avatar } from "primereact/avatar";
import { routes } from "../../routes";
import Sidebars from "../../components/dashboard/sidebar/Sidebar";
import Header from "../../components/dashboard/header/Header";

export default function DashboardLayout() {
  //const [dynamicWithSidebar, setDynamicWithSidebar] = useState(false)
  const [iconSize, setIconSize] = useState(false);
  const [appContent, setAppContent] = useState(false);
  const [navWidth, setNavWidth] = useState(false);
  const [collapsed, setCollapsed] = useState(false);

  function handleClickIcon(e) {
    e.preventDefault();
    //setDynamicWithSidebar(!dynamicWithSidebar)
    /* setIconSize(!iconSize);
    setAppContent(!appContent);
    setNavWidth(!navWidth); */
    setCollapsed((collapsed) => {
      return !collapsed;
    });
  }
  return (
    <div className="app-wrap dashboard">
      <Sidebars collapsed={collapsed} />
      {/*<Sidebar dynamicWith = {dynamicWithSidebar?'active':''} iconSize = {iconSize?"active":''}/>*/}
      <div className={`app-content ${collapsed ? "active" : ""}`}>
        <Header
          onClick={handleClickIcon}
          navWidth={collapsed ? "active" : ""}
        />
        <main className="main">
          <Outlet />
        </main>
      </div>
    </div>
  );
}
